import { meansApplyPlan } from '../flow-definition';
import type { Command } from '../types';

/**
 * **What more than one step uses** (docs/RESOLUTION.md §1): the adapter that
 * reads the plain commands out of an act compiler's apply plan (steps 4 and 6
 * both compile through `meansApplyPlan`). Nothing here decides anything; a
 * helper that belongs to one step lives in that step's file. The words the
 * steps speak are catalog keys (src/i18n/messages/en/resolution.ts), plurals
 * included, so no step builds a phrase of its own.
 */

/** The `dispatch` actions of an apply plan as plain commands. Tag and field
 *  pairs are the flow machinery's own writes and are not contract commands, so
 *  they do not ride a resolver step. */
export function dispatchedCommands(actions: ReturnType<typeof meansApplyPlan>): Command[] {
  const out: Command[] = [];
  for (const action of actions) if (action.kind === 'dispatch') out.push(action.command);
  return out;
}
